package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.feature.domain.repository.answer.AnswerChunkFileRepository

actual suspend fun deleteChunkFileAfterUpload(
    repository: AnswerChunkFileRepository,
    chunkId: String
) {
    // no-op on web
}
